<SettingsLayout page='settings/about' label="{$messages["aboutApp"]}">
  <div ref:node>
    <h1>{$messages["aboutApp"]}</h1>
    {@html $messages["aboutAppDescription"]}
  </div>
</SettingsLayout>
<UISettingsStyles />
<script>
  import SettingsLayout from '../../_components/settings/SettingsLayout.html'
  import UISettingsStyles from '../../_components/settings/UISettingsStyles.html'

  const version = ZOCIAL_VERSION
  // branch-based channel, spelled out to match the startup banner
  const channelLabel = ZOCIAL_CHANNEL === 'prod' ? 'Production' : 'Development'

  export default {
    oncreate () {
      for (const node of this.refs.node.querySelectorAll('.zocial-version')) {
        // keep the version number in the monospace <code>, but put the channel right
        // after it as normal text — a monospace space would look too wide otherwise
        node.textContent = version
        node.insertAdjacentText('afterend', ` (${channelLabel})`)
      }
    },
    components: {
      SettingsLayout,
      UISettingsStyles
    }
  }
</script>
